import React, {useState} from 'react';
import {CalendlyModal} from "~/components/elements/CalendlyModal";

export const ScheduleConsultColumns = (props) => {
  const { columnA, columnB, sectionBackgroundImage } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const linkType = columnB.type;
  const isCalendly = linkType === "calendly";
  const linkUrl = columnB.link.url;
  const linkTitle = columnB.link.title;
  const linkTarget = columnB.link.target;


  return (
    <section className="relative w-full font-sans overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${sectionBackgroundImage?.localFile?.publicURL || '/hearing-bg.jpg'})`,
        }}
      >
        {/* Semi-transparent Overlay */}
        <div className="absolute inset-0  opacity-40" />
      </div>

      {/* Content Grid */}
      <div className="main-content-section relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center  py-16 md:py-24">
        {/* Left Column (Text Section) */}
        <div className="text-white space-y-6 max-w-xl mx-auto">
          <h2 className="text-[38px] text-white  font-bold leading-snug">
            {columnA?.heading}
          </h2>
          <div
            className="space-y-4 text-base text-white/90 pt-consult-text mr-[4rem] pt-scheduleconsult-text"
            dangerouslySetInnerHTML={{ __html: columnA?.content }}
          />
        </div>

        {/* Right Column (Card) */}
        <div className=" p-6 md:p-8 rounded-[24px] shadow-xl max-w-[588px] h-[595px] text-center space-y-12 bg-[rgba(246,249,255,1)] pt-scheduleconsult-card-container">
          {/* Title */}
          <h3 className="text-2xl font-bold text-gray-900 leading-tight text-left">
            {columnB?.title}
          </h3>

          {/* Circular Images */}
          {columnB?.images?.length > 0 && (
            <div className="flex justify-left  md:gap-10 pt-schedule">
              {columnB.images.map((image, index) => (
                <img
                  key={index}
                  src={image.image.localFile.publicURL}
                  alt={image.image.altText || ''}
                  className="w-[182px] h-[182px] rounded-full object-cover"
                  loading="lazy"
                />
              ))}
            </div>
          )}

          {/* CTA Button */}

          {isCalendly ? (
            <>
              <CalendlyModal isOpen={modalOpen} onClose={() => setModalOpen(false)} calendlyUrl={linkUrl} />
              <button onClick={() => setModalOpen(true)} className="pt-consultant-button" style={{background: 'rgba(78,134,245,1)', color: 'white' }}>
                {linkTitle}
              </button>
            </>
          ) : (
            <a href={linkUrl} target={linkTarget || "_self"} rel="noopener noreferrer" style={{background: 'rgba(78,134,245,1)', color: 'white'}} className="pt-consultant-button">
              {linkTitle}
            </a>
          )}

          {/* Disclaimer Text */}
          {columnB.content && (
            <p
              className="text-xs text-gray-500 leading-snug"
              dangerouslySetInnerHTML={{ __html: columnB.content }}
            />
          )}
        </div>
      </div>
    </section>
  );
};